import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import styled, { createGlobalStyle, css } from 'styled-components'

export const HideNav = createGlobalStyle`
  @media ${DEVICES.mobile} {
    body.modal-open main {
      z-index: 1000 !important;
    }
  }
`

export const MainStyle = createGlobalStyle`
  @media ${DEVICES.tabletMini} and (orientation: landscape) {
    body.modal-open main {
      z-index: 1000 !important;
    }
  }
`

const CarouselButtonStyle = css`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.white};
  color: ${COLORS.secondary};
  cursor: pointer;
  position: absolute;
  z-index: 999;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.25s ease-in;

  &.slick-disabled {
    display: none;
  }

  &:before {
    display: none;
  }

  svg {
    position: relative;
  }

  &:hover {
    background-color: ${COLORS.secondary};
    color: ${COLORS.white};
  }
`

export const GalleryItem = styled.div`
  height: 100%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.sand};

  .floorplan {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: auto;
      width: auto;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    -webkit-touch-callout: default;
    -webkit-user-select: default;
    -khtml-user-select: default;
    -moz-user-select: default;
    -ms-user-select: default;
    user-select: default;
  }

  div {
    width: 100%;
    height: 100%;
  }
`

export const GalleryMain = styled.div`
  flex: 1;
  background-color: #000;
  width: calc(100% - 352px);
  height: 100%;

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slider .slick-next {
    right: 20px;

    svg {
      right: -1px;
    }
  }

  .slick-slider .slick-prev {
    left: 20px;

    svg {
      left: -1px;
    }
  }

  .slick-next,
  .slick-prev {
    ${CarouselButtonStyle};
  }

  .slick-slide > div {
    height: 100%;
  }

  ${({ fullwidth }) =>
    fullwidth &&
    css`
      width: 100%;

      ${GalleryItem} img {
        object-fit: cover;
      }
    `}

  ${({ fullscreen }) =>
    fullscreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      @media ${DEVICES.mobile} {
        width: 100%;
        height: 100%;
      }
    `}

  @media ${DEVICES.mobile} {
    width: 100%;
  }
`

export const CarouselWrapper = styled.div`
  .slick-slide > div {
    margin-right: 24px;
  }
`

export const CarouselNext = styled.div``
export const CarouselPev = styled.div``

export const btnStyle = css`
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.white};
  color: ${COLORS.secondary};
  box-shadow: none;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${COLORS.secondary};
    color: ${COLORS.white};
  }
`

export const GalleryActions = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  z-index: 1000;

  button {
    ${btnStyle};

    svg {
      width: 20px;
      height: 20px;
      flex: 0 0 20px !important;
    }

    &:disabled {
      background-color: ${COLORS.nature[95]};
      color: ${COLORS.secondary};
      cursor: not-allowed;
      opacity: 0.75;
    }
  }

  @media ${DEVICES.tabletMini} {
    button {
      display: none;
    }
  }

  @media ${DEVICES.tabletMini} {
    right: 16px;
    bottom: 38px;
  }
`

export const DownloadButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const DownloadButton = styled.button`
  ${btnStyle};

  svg {
    width: 20px !important;
    height: 20px !important;
    flex: 0 0 20px !important;
  }

  @media ${DEVICES.tabletMini} {
    display: inline-flex !important;
  }
`

export const FullscreenButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const FullscreenButton = styled.button`
  ${btnStyle};
  svg {
    width: 16px !important;
    height: 16px !important;
    flex: 0 0 16px !important;
  }

  @media ${DEVICES.tabletMini} {
    display: inline-flex !important;
  }
`

export const CloseFullscreenButton = styled.button`
  ${btnStyle};
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;

  svg {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
  }
`

